import { useEffect, useState, useCallback } from "react";
import { ArrowRight } from "lucide-react";
import { PageHeader, GlassCard, EmptyState, GradButton } from "@/components/erp";
import { IsEmriDetay, DevirDialog, adimBirim } from "@/components/IsEmriDetay";
import { Ilerleme } from "@/pages/UretimPlani";
import api from "@/lib/api";

export default function Islerim() {
  const [list, setList] = useState([]);
  const [personel, setPersonel] = useState([]);
  const [nedenler, setNedenler] = useState({});
  const [devir, setDevir] = useState(null);
  const [detay, setDetay] = useState(null);
  const load = useCallback(async () => setList((await api.get("/is-emirleri/islerim")).data), []);
  useEffect(() => {
    load();
    api.get("/uretim/personel").then((r) => setPersonel(r.data));
    api.get("/istasyonlar").then((r) => setNedenler(Object.fromEntries(r.data.map((i) => [i.id, i.fire_nedenleri || []])))).catch(() => {});
  }, [load]);
  const kartlar = list.flatMap((e) => e.benim_adimlar.map((i) => ({ e, i })));

  return (
    <div data-testid="islerim-page">
      <PageHeader eyebrow="Üretim" title="İşlerim" desc="Size devredilen istasyonlarda bekleyen adetler. İşlediğiniz kadarını parça parça sonraki istasyona devredin; hatalı çıkanı fire olarak nedeniyle yazın." />
      {kartlar.length === 0 ? <GlassCard><EmptyState text="Üzerinizde bekleyen iş yok." testid="islerim-bos" /></GlassCard> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {kartlar.map(({ e, i }) => {
            const a = e.rota[i];
            const sonraki = e.rota[i + 1];
            return (
              <GlassCard key={`${e.id}-${i}`} className="p-6 fade-up" data-testid={`is-kart-${e.no}-${i}`}>
                <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--g1)]">{a.ad}{a.atanan_id ? "" : " · kuyruk"}</div>
                <div className="font-head text-xl font-semibold mt-1">{e.ad}</div>
                <div className="text-sm text-muted-foreground">{e.no}{e.termin_tarihi ? ` · termin ${e.termin_tarihi}` : ""}</div>
                <div className="text-sm mt-2">Bekleyen <b className="font-mono" data-testid={`is-bekleyen-${e.no}-${i}`}>{a.bekleyen}</b> {adimBirim(e, a)} <span className="text-xs text-muted-foreground">/ plan {a.birim === "ham" ? `${e.kesim?.ham} ham (${e.miktar} ${e.birim})` : e.miktar}</span></div>
                <Ilerleme ie={e} />
                <div className="text-xs text-muted-foreground mt-2 flex items-center gap-1">{sonraki ? <>Sonraki <ArrowRight className="w-3 h-3" /> {sonraki.ad}</> : "Son istasyon — devredilen stoğa girer"}</div>
                <div className="flex gap-2 mt-4">
                  <GradButton data-testid={`is-devir-${e.no}-${i}`} onClick={() => setDevir({ e, i })}>{sonraki ? "Tamamla & devret" : "Stoğa al"}</GradButton>
                  <button data-testid={`is-detay-${e.no}-${i}`} onClick={() => setDetay(e.id)} className="px-4 py-2 rounded-full border border-white/10 text-sm hover:bg-white/5">Detay</button>
                </div>
              </GlassCard>
            );
          })}
        </div>
      )}
      {devir && <DevirDialog ie={devir.e} idx={devir.i} personel={personel} nedenler={nedenler[devir.e.rota[devir.i].istasyon_id] || []} onClose={() => setDevir(null)} onDone={() => { setDevir(null); load(); }} />}
      {detay && <IsEmriDetay id={detay} onClose={() => { setDetay(null); load(); }} onChanged={load} />}
    </div>
  );
}
